import script from "./time-shortcut-select.vue?vue&type=script&setup=true&lang=js"
export * from "./time-shortcut-select.vue?vue&type=script&setup=true&lang=js"

import "./time-shortcut-select.vue?vue&type=style&index=0&id=40c81d5f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c81d5f"]])

export default __exports__